import Post from "./Post.presenter";
export default Post;
